export const scrollToTop = (elementClassName) => {
  const element = document.querySelector(elementClassName);

  if (!element) {
    return;
  }

  element.scroll(0, 0);
};
